<script setup lang="ts">
import {
  defineModel,
  ref,
  computed,
  InputTypeHTMLAttribute,
  useTemplateRef,
  onMounted,
} from "vue";
import IMask, { type InputElement } from "imask";

interface Props {
  label?: string;
  mask?: string;
  required?: boolean;
  type?: InputTypeHTMLAttribute;
  errorMessage?: string;
}

const props = defineProps<Props>();

const model = defineModel<string>({ default: "" });
const isShowPassword = ref(false);
const isPassword = computed(() => props.type === "password");
const inputElement = useTemplateRef<InputElement>("inputRef");

const setMask = () => {
  if (props.mask) {
    IMask(inputElement.value as InputElement, { mask: props.mask });
  }
};

onMounted(() => {
  setMask();
});
</script>

<template>
  <div class="form-group form-row">
    <label class="control-label" :class="[props.required ? 'required' : '']">
      <slot name="label">
        {{ props.label }}
      </slot>
    </label>

    <span
      v-if="props.errorMessage"
      class="color-error inline-flex ml-4 text-small"
    >
      {{ errorMessage }}
    </span>

    <div v-if="props.type === 'password'" class="ce-input__container">
      <input
        v-bind="$attrs"
        v-model="model"
        class="form-control ce-input ce-input__password"
        :type="isShowPassword ? 'text' : 'password'"
      />
      <i
        v-if="isPassword"
        class="color-passive ce-input__password-icon"
        :class="isShowPassword ? 'raberu-icon-hide' : 'raberu-icon-eye'"
        @click="isShowPassword = !isShowPassword"
      ></i>
    </div>

    <input
      v-else
      ref="inputRef"
      v-bind="$attrs"
      v-model="model"
      class="form-control ce-input"
      :type="props.type"
    />
  </div>
</template>

<style scoped lang="scss">
.ce-input {
  margin-top: 7px;
}

.ce-input__container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.ce-input__password {
  margin-bottom: 0;
}

.ce-input__password-icon {
  position: absolute;
  right: 10px;
  top: 15px;
  cursor: pointer;
  font-size: 18px;
}
</style>
